/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function HeartOutlined({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M1.588 2.599a4.037 4.037 0 0 1 5.741 0l.002.001.68.688.673-.68a4.02 4.02 0 0 1 5.73 0 4.101 4.101 0 0 1 0 5.77c-1 1.007-1.998 2.015-2.996 3.022a4332.9 4332.9 0 0 1-2.996 3.023.6.6 0 0 1-.852-.001L1.586 8.37a4.102 4.102 0 0 1 0-5.77l.002-.001Zm.85.846a2.902 2.902 0 0 0 .002 4.082l5.557 5.62 2.569-2.591a4715.06 4715.06 0 0 1 2.995-3.023 2.902 2.902 0 0 0 0-4.081 2.82 2.82 0 0 0-4.024 0l-1.1 1.11a.6.6 0 0 1-.852 0L6.479 3.447a2.838 2.838 0 0 0-4.04 0Z" clipRule="evenodd" /></svg>;
}
;